import * as React from "react";


export const InfoContainer = ({ children }: { children: React.ReactNode }) => (
    <div
        style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
        }}
    >
        {children}
    </div>
);


// WEBPACK FOOTER //
// ./src/components/householdInsurance/components/HouseholdInsuranceInfoContainer.tsx